import { Dispatch, ReactNode, SetStateAction } from 'react'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
} from '@/components/ui/dialog'
import { X } from 'lucide-react'
import { DialogTitle } from '@radix-ui/react-dialog'

export interface CommonModalProps {
  open: boolean
  onOpenChange?: Dispatch<SetStateAction<boolean>> | ((open: boolean) => void)
  children: ReactNode
  title?: string
  isHeader?: boolean
  isCloseButton?: boolean
  className?: string
  contentClassName?: string
}

const CommonModal = ({
  open,
  onOpenChange,
  children,
  title,
  isHeader = false,
  isCloseButton = false,
  className = '',
  contentClassName = '',
}: CommonModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={`common_modal p-0 gap-0 rounded-lg modal ${className}`}
      >
        {(title || isHeader) && (
          <DialogHeader className="flex flex-row items-center justify-between p-5 border-b border-solid border-gray-100">
            <DialogTitle className="text-heading-md font-bold text-left">
              {title}
            </DialogTitle>
            {isCloseButton && (
              <DialogClose>
                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">
                  <X size={20} className="text-gray-800" />
                </div>
              </DialogClose>
            )}
          </DialogHeader>
        )}
        <div className={`p-6 ${contentClassName}`}>{children}</div>
      </DialogContent>
    </Dialog>
  )
}

export default CommonModal
